// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_data.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentConfig } from "./experiment_config_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_config } from "./experiment_config_pb";
import type { ExperimentMetadata } from "./experiment_metadata_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_metadata } from "./experiment_metadata_pb";
import type { ExperimentResults } from "./experiment_results_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_results } from "./experiment_results_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_data.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_data: GenFile = /*@__PURE__*/
  fileDesc("Cj1xdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9kYXRhLnByb3RvEidxdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEimgMKDkV4cGVyaW1lbnREYXRhEhoKDWV4cGVyaW1lbnRfaWQYASABKAlIAIgBARJdChNleHBlcmltZW50X21ldGFkYXRhGAIgASgLMjsucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkV4cGVyaW1lbnRNZXRhZGF0YUgBiAEBElkKEWV4cGVyaW1lbnRfY29uZmlnGAMgASgLMjkucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkV4cGVyaW1lbnRDb25maWdIAogBARJbChJleHBlcmltZW50X3Jlc3VsdHMYBCABKAsyOi5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuRXhwZXJpbWVudFJlc3VsdHNIA4gBAUIQCg5fZXhwZXJpbWVudF9pZEIWChRfZXhwZXJpbWVudF9tZXRhZGF0YUIUChJfZXhwZXJpbWVudF9jb25maWdCFQoTX2V4cGVyaW1lbnRfcmVzdWx0c2IGcHJvdG8z", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_config, file_quanterix_simoa_one_analysis_app_api_v1_experiment_metadata, file_quanterix_simoa_one_analysis_app_api_v1_experiment_results]);

/**
 * Represents all data owned by a single experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentData
 */
export type ExperimentData = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentData"> & {
  /**
   * Unique id (UUID) of this experiment
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * Metadata describing this experiment
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentMetadata experiment_metadata = 2;
   */
  experimentMetadata?: ExperimentMetadata;

  /**
   * Experiment setup and configuration options defining the parameters
   * used for analyzing collected data
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentConfig experiment_config = 3;
   */
  experimentConfig?: ExperimentConfig;

  /**
   * Analysis outputs for this experiment
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentResults experiment_results = 4;
   */
  experimentResults?: ExperimentResults;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentData.
 * Use `create(ExperimentDataSchema)` to create a new message.
 */
export const ExperimentDataSchema: GenMessage<ExperimentData> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_data, 0);

